<template>
  <div class="no-setting">
    <div class="pic" :style="{backgroundImage: 'url('+ imgSrc +')'}"></div>
    <span>{{text}}</span>
  </div>
</template>
<script>
export default {
  name: 'NoData',
  props: {
    imgSrc: String,
    text: String
  }
}
</script>
<style lang="stylus" scoped>
  .no-setting
    padding-top 18px
    text-align center
    background #ffffff
    width 100%
    .pic
      width 153px
      height 134px
      background-position center center
      background-repeat no-repeat
      background-size contain
      margin 0 auto
    span
      display inline-block
      height 51px
      line-height 51px
      font-size 16px
      color #333333
</style>


// WEBPACK FOOTER //
// src/components/NoData/NoData.vue